import { render, staticRenderFns } from "./EGBScoreTab.vue?vue&type=template&id=1b386854&"
import script from "./EGBScoreTab.vue?vue&type=script&lang=js&"
export * from "./EGBScoreTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports